
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useForm } from 'react-hook-form';
import Loader from "react-js-loader";
import * as Yup from 'yup';
//import '../Scss/login.scss';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { Toast } from 'primereact/toast';
import { getEndpointUrl } from "../Utils/Common";
import BrandLogo from '../logo.png';

export default function Login() {
    const [isLoading, setLoading] = useState(false);

    const toast = useRef(null);

    useEffect(() => {

    }, [isLoading]);

    const validationSchema = Yup.object().shape({
        username: Yup.string()
            .required('Username harus diisi'),
        password: Yup.string()
            .required('Password harus diisi')
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        setLoading(true);

        let formData = new FormData();    //formdata object

        formData.append('username', data.username);
        formData.append('password', data.password);

        fetch(getEndpointUrl() + '/users/login', {
            method: "POST",
            body: formData,
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.current.show({ severity: 'success', summary: 'Berhasil', detail: json.message });

                localStorage.setItem('knowLogin', JSON.stringify(json.results));

                localStorage.setItem('credentials', JSON.stringify(json.tokenAccess));

                window.location.assign('/')
            } else if(json.status === 'password_not_valid') {
                toast.current.show({ severity: 'warn', summary: 'Gagal', detail: "Kombinasi password tidak valid!" });
            } else if(json.status === 'user_not_valid') {
                toast.current.show({ severity: 'warn', summary: 'Gagal', detail: "User tidak valid!" });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <Helmet>
                <title>Login - Car Inspector</title>
            </Helmet>
            <Toast ref={toast} />
            <Container>
                <Row>
                    <Col md={6} lg={4} className="offset-md-3 offset-lg-4 mt-5 pt-3">
                        <div className='d-flex justify-content-center'>
                            <Image src={BrandLogo} alt="Brand Logo" fluid className=" mb-3" />
                        </div>
                        <div className="login-page p-3 border rounded-3 mt-3">
                            <h1 style={{fontSize:'16px'}}>Login</h1>
                            <p className="fs-13">Masukkan username dan password login anda.</p>
                            {isLoading ?
                                <div className="d-flex justify-content-center mt-5 pt-5 mb-3">
                                    <Loader type="bubble-scale" bgColor={"#EF9A9A"} size={100} />
                                </div> :
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Username</Form.Label>
                                        <Form.Control type="text" {...register("username")} placeholder='Masukkan username' isInvalid={errors.username ? true : false} autoComplete="off" />
                                        <Form.Text className="text-muted clearfix">{errors.username?.message}</Form.Text>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control type="password" {...register("password")} placeholder='Masukkan password' isInvalid={errors.password ? true : false} autoComplete="off" />
                                        <Form.Text className="text-muted clearfix">{errors.password?.message}</Form.Text>
                                    </Form.Group>
                                    <Form.Group className="mt-4">
                                        <div className="d-grid gap-2">
                                            <Button type="submit" size="lg" variant="danger">Login</Button>
                                        </div>
                                    </Form.Group>
                                </Form>
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}